import "./Dashboard.css";
import PuzzleTable from "./PuzzleTable";

const Dashboard = (props) => {
  const {onClickCreateGame, dashboadPuzzles,} = props
  return (
    <div className="dashboard-container">
      <div className="puzzle-table-header-container">
        <div className="puzzle-table-header-title">
          <h1>Your Puzzles</h1>
        </div>
        <div className="puzzle-table-header-container-spacer"></div>
        <div name='create-puzzle-button' className="puzzle-table-header-create-puzzle" onClick={onClickCreateGame}>
          Create Puzzle
        </div>
      </div>
      <PuzzleTable dashboadPuzzles={dashboadPuzzles}/>
    </div>
  );
};

export default Dashboard;
